/**
 * Focuses and scrolls to the first invalid field in a form.
 * Works with both regular inputs and dropdowns (searches for focusable element inside container).
 *
 * @param fieldOrder - Field IDs in display order
 * @param isFieldInvalid - Function that returns true if a field is invalid
 */
export function focusFirstInvalidField(fieldOrder: string[], isFieldInvalid: (id: string) => boolean): void {
    const firstFailed = fieldOrder.find(id => isFieldInvalid(id))
    if (!firstFailed) return

    const el = document.getElementById(firstFailed)
    if (!el) return

    // Use 'center' so the field (including its label above) is visible, not pinned to the edge
    el.scrollIntoView({ behavior: 'smooth', block: 'center' })

    // For dropdowns and complex components, the focusable element may be nested inside
    const focusable = el.matches('input, textarea, select')
        ? el
        : el.querySelector('input, textarea, select') as HTMLElement | null

    ;(focusable ?? el)?.focus()
}
